import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/img/icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-07e15de4")

_pushScopeId("data-v-07e15de4")
const _hoisted_1 = /*#__PURE__*/_createVNode("img", {
  class: "sentinels7-logo",
  src: _imports_0,
  alt: "your image"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("SentinelS7 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("SentinelS7 Development Site")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_note = _resolveComponent("ion-note")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_menu_toggle = _resolveComponent("ion-menu-toggle")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_menu = _resolveComponent("ion-menu")
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")
  const _component_IonSplitPane = _resolveComponent("IonSplitPane")
  const _component_IonApp = _resolveComponent("IonApp")

  return (_openBlock(), _createBlock(_component_IonApp, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, null, {
        default: _withId(() => [
          _createVNode(_component_ion_buttons, { start: "" }, {
            default: _withId(() => [
              (_ctx.currentRouteName != '/login')
                ? (_openBlock(), _createBlock(_component_ion_menu_button, { key: 0 }))
                : _createCommentVNode("", true),
              _hoisted_1,
              _createVNode(_component_ion_toolbar, null, {
                default: _withId(() => [
                  (!_ctx.isSiteDev)
                    ? (_openBlock(), _createBlock(_component_ion_title, { key: 0 }, {
                        default: _withId(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_ion_title, {
                        key: 1,
                        class: "ionbuttonsdev",
                        color: "red"
                      }, {
                        default: _withId(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_IonSplitPane, { "content-id": "main-content" }, {
        default: _withId(() => [
          (_ctx.currentRouteName != '/login')
            ? (_openBlock(), _createBlock(_component_ion_menu, {
                key: 0,
                "content-id": "main-content",
                type: "overlay"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_content, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_list, { id: "sentinels7-list" }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_note, null, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.currentUserEmail), 1)
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.appPages, (p, i) => {
                            return (_openBlock(), _createBlock(_component_ion_menu_toggle, {
                              "auto-hide": "false",
                              key: i
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_ion_item, {
                                  onClick: ($event: any) => {_ctx.selectedIndex = i;_ctx.clickedMenuItem(p)},
                                  "router-direction": "root",
                                  "router-link": p.url,
                                  lines: "none",
                                  detail: "false",
                                  class: ["hydrated", { selected: _ctx.selectedIndex === i }]
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_ion_icon, {
                                      slot: "start",
                                      ios: p.iosIcon,
                                      md: p.mdIcon
                                    }, null, 8, ["ios", "md"]),
                                    _createVNode(_component_ion_label, null, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString(p.title), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick", "router-link", "class"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_router_outlet, { id: "main-content" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})